// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Icon, Tooltip } from "@mui/material";

// Kaizen Dashboard components
import SoftBox from "components/SoftBox";

// Custom styles for the SidenavCollapse
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "components/Sidenav/styles/sidenavCollapse";

// Kaizen Dashboard context
import { useSoftUIController } from "context";

function SubItem({ color, icon, name, children, active, noCollapse, open, ...rest }) {
  const [controller] = useSoftUIController();
  const { miniSidenav, transparentSidenav } = controller;

  const acortarNombre = (nombre) => {
    //acortar a 12 caracteres y agregar puntos suspensivos si es necesario
    if (nombre.length > 12) {
      return nombre.substring(0, 12) + "...";
    }
    return nombre;
  };

  return (
    <>
      <ListItem component="li" sx={{ marginLeft: "30px" }}>
        {/* <Tooltip title={name} placement="top"> */}
        <SoftBox {...rest} sx={(theme) => collapseItem(theme, { active })}>
          <ListItemIcon
            sx={(theme) => collapseIconBox(theme, { active, transparentSidenav, color })}
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={acortarNombre(name)}
            sx={(theme) => collapseText(theme, { miniSidenav, transparentSidenav, active })}
          />
        </SoftBox>
        {/* </Tooltip> */}
      </ListItem>
    </>
  );
}

// Setting default values for the props of SidenavCollapse
SubItem.defaultProps = {
  color: "primary",
  active: false,
  noCollapse: false,
  children: false,
  open: false,
};

// Typechecking props for the SidenavCollapse
SubItem.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
};

export default SubItem;
